module.exports = __webpack_public_path__ + "img/CNY.1b47abb8.svg";